//
//
//
//
//
//
//
//
export default {
  name: 'IntersectingCirclesSpinner',
  props: {
    animationDuration: {
      type: Number,
      "default": 1200
    },
    size: {
      type: Number,
      "default": 70
    },
    color: {
      type: String,
      "default": '#fff'
    }
  },
  computed: {
    circleSize: function circleSize() {
      return this.size / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: "".concat(this.size, "px"),
        height: "".concat(this.size, "px")
      };
    },
    spinnerBlockStyle: function spinnerBlockStyle() {
      return {
        animationDuration: "".concat(this.animationDuration, "ms"),
        width: "".concat(this.circleSize, "px"),
        height: "".concat(this.circleSize, "px")
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color
      };
    },
    circleStyles: function circleStyles() {
      var _this = this;

      var circlesPositions = [{
        top: 0,
        left: 0
      }, {
        left: "".concat(this.circleSize * -0.36, "px"),
        top: "".concat(this.circleSize * 0.2, "px")
      }, {
        left: "".concat(this.circleSize * -0.36, "px"),
        top: "".concat(this.circleSize * -0.2, "px")
      }, {
        left: 0,
        top: "".concat(this.circleSize * -0.36, "px")
      }, {
        left: "".concat(this.circleSize * 0.36, "px"),
        top: "".concat(this.circleSize * -0.2, "px")
      }, {
        left: "".concat(this.circleSize * 0.36, "px"),
        top: "".concat(this.circleSize * 0.2, "px")
      }, {
        left: 0,
        top: "".concat(this.circleSize * 0.36, "px")
      }];
      return circlesPositions.map(function (cp) {
        return Object.assign(cp, _this.circleStyle);
      });
    }
  }
};